import React, { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import NodeWrapper from "./NodeWrapper";
import useHandleConnected from "./useHandleConnected";
import { DynamicFeed } from "@mui/icons-material";

const MenuNode = memo(({ id, data, isConnectable, selected }) => {
  const getHandleClass = useHandleConnected(id);
  const options = data?.arrayOption || [];
  const message = data?.message || "";

  return (
    <NodeWrapper
      id={id}
      data={data}
      icon={<DynamicFeed />}
      title="Menu"
      color="#683AC8"
      bgColor="#FAFBFF"
      noSource
      isConnectable={isConnectable}
      selected={selected}
      minWidth={220}
    >
      {/* Message preview */}
      {message && (
        <div
          style={{
            fontSize: 11,
            color: "#333",
            lineHeight: 1.4,
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxWidth: 200,
            background: "#F3EEFF",
            borderRadius: 6,
            padding: "5px 8px",
            marginBottom: 8,
            borderLeft: "3px solid #683AC8",
          }}
        >
          <span style={{ marginRight: 4 }}>{"✅"}</span>
          {message}
        </div>
      )}

      {/* Option list with handles at node edge */}
      <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
        {options.map((opt) => (
          <div
            key={opt.number}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "4px 8px",
              background: "#fff",
              border: "1px solid #E8E0F5",
              borderRadius: 6,
              fontSize: 11,
              color: "#333",
              position: "relative",
            }}
          >
            <span
              style={{
                background: "#683AC8",
                color: "#fff",
                borderRadius: 4,
                padding: "0 6px",
                fontSize: 10,
                fontWeight: 700,
                flexShrink: 0,
              }}
            >
              {opt.number}
            </span>
            <span
              style={{
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {opt.value || "..."}
            </span>
            <Handle
              type="source"
              position={Position.Right}
              id={"a" + opt.number}
              className={getHandleClass("source", "a" + opt.number)}
              style={{
                position: "absolute",
                top: "50%",
                right: -21,
                transform: "translateY(-50%)",
                cursor: "crosshair",
              }}
              isConnectable={isConnectable}
            />
          </div>
        ))}
      </div>
    </NodeWrapper>
  );
});

MenuNode.displayName = "MenuNode";
export default MenuNode;
